<template>
  <div style="padding: 0.22rem">
    <div>
      <div class="left_title">素材管理</div>
      <div
        @click="leftGoto('/materialUpload')"
        class="left_tab"
        :class="left_tabShow == 'material_upload' ? 'left_tab_select' : ''"
      >
        上传素材
      </div>
      <div
        @click="leftGoto('/newTrialMaterial')"
        class="left_tab"
        :class="left_tabShow == 'new_trial_material' ? 'left_tab_select' : ''"
      >
        在审素材
      </div>
      <div
        @click="leftGoto('/onSaleMaterial')"
        class="left_tab"
        :class="left_tabShow == 'on_sale_material' ? 'left_tab_select' : ''"
      >
        在售素材
      </div>
      <div
        @click="leftGoto('/purchasedMaterial')"
        class="left_tab"
        :class="left_tabShow == 'purchased_material' ? 'left_tab_select' : ''"
      >
        已购素材
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
const router = useRouter();

defineProps({
  left_tabShow: String,
});
//直接跳转
const leftGoto = (type) => {
  //  初始化缓存
  if (type == "/materialUpload") {
    localStorage.setItem("scsc", "VIDEO");
  }
  if (type == "/newTrialMaterial") {
    localStorage.setItem("zssc", 'first');
    localStorage.setItem("zssc_type", "");
  }

  //跳转
  router.push(type);
};
</script>

<style scoped>
.left_title {
  font-size: 0.12rem;
  margin-bottom: 0.2rem;
  color: #86909c;
}

.left_tab {
  font-size: 0.14rem;
  margin-bottom: 0.2rem;
  color: #333333;
  cursor: pointer;
}

.left_tab_select {
  color: #C01A26;
}
</style>
